// @flow
import React from 'react';
import * as cssComviq from './FooterComviq.module.css';
import * as cssTele2 from './FooterTele2.module.css';

type PropType = {
  children?: React.Node,
  isScrolled?: boolean,
  isComviq: boolean,
  className: string,
};

const Footer = ({ children, isScrolled = false, isComviq = false, className }: PropType) => {
  const css = isComviq ? cssComviq : cssTele2;
  const cssClass = isScrolled ? `${css.footer} ${css.scrolled} ${className}` : `${css.footer} ${className}`;
  return <div className={cssClass}>{children}</div>;
};

export default React.memo(Footer);
